const copyTextWithExecCommand = value => {
  if (typeof document === "undefined") return false;

  let textArea = document.createElement("textarea");
  textArea.value = value;
  textArea.setAttribute("readonly", "");
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";
  document.body.appendChild(textArea);
  textArea.select();
  textArea.setSelectionRange(0, value.length);

  try {
    return typeof document.execCommand === "function"
      ? document.execCommand("copy")
      : false;
  } finally {
    document.body.removeChild(textArea);
    textArea = null;
  }
};

export const copyTextToClipboard = async text => {
  const safeText = text || "";
  const clipboard =
    typeof navigator !== "undefined" ? navigator.clipboard : null;

  if (clipboard?.writeText) {
    try {
      await clipboard.writeText(safeText);
      return true;
    } catch (_error) {
      // Fall back to execCommand for browsers with clipboard API restrictions.
      return copyTextWithExecCommand(safeText);
    }
  }

  return copyTextWithExecCommand(safeText);
};
